module.exports = __webpack_public_path__ + "851209675f693ed9d21d40180f75bf5e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/about/static/background-image.jpg
// module id = 253
// module chunks = 0